module.exports = __webpack_public_path__ + "media/images/home/teacher_icon_2-7f9bdd896fc69d5bf4e32b62f4834f9b.svg";